export default __webpack_public_path__ + "bdcaa1c57e4d793d969524ec06e12712.jpg";